"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var backdropStyles = function backdropStyles(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:rgba(", theme.color.monochrome.black_rgba, ", 0.35);" + (process.env.NODE_ENV === "production" ? "" : ";label:backdropStyles;"));
};

var panel = function panel(theme) {
  return /*#__PURE__*/(0, _react.css)("max-width:", (0, _util.rem)(617), ";padding:", (0, _util.rem)(32), " ", (0, _util.rem)(40), ";box-shadow:0 2px 4px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);" + (process.env.NODE_ENV === "production" ? "" : ";label:panel;"));
};

var styles = {
  backdropStyles: backdropStyles,
  panel: panel
};
exports.styles = styles;
//# sourceMappingURL=Modal.styles.js.map